<template>
  <Flickity
    v-if="plantParam.length"
    class="flickity"
    ref="flickity"
    :options="options"
  >
    <Card
      class="pa-2 ma-1 carousel-cell"
      v-for="(param, index) in plantParam"
      :key="index"
    >
      <div class="title pb-1 pt-1 text-xs-center">
        <span
          :class="
            param.data == null || param.data == 'No Data'
              ? 'error--text'
              : 'number--text'
          "
          >{{ param.data }}</span
        ><span class="grey--text caption">({{ param.unit }})</span>
      </div>
      <div class="body-2 text-xs-center text--grey">{{ $t(param.header) }}</div>
    </Card>
  </Flickity>
</template>

<script>
import { mapGetters } from "vuex";
import LiveDb from "@/services/LiveDb";
import Flickity from "vue-flickity";
import { mapGettersMixin } from "@/util/mixin/index";

export default {
  mixins: [mapGettersMixin],
  components: {
    Flickity,
  },
  data() {
    return {
      plantParam: [],
      options: {
        // initialIndex: 1,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        freeScroll: true,
        contain: true,
        percentPosition: false,
      },
      deviceOrder: ["Inverter", "MFM", "Energy Meter", "Weather Station"],
    };
  },
  computed: {
    ...mapGetters(["getSelectedPlantId", "getRules"]),
    availableDeviceWithParameter() {
      const accessConfig = this.getRules(["rule", "access_config"]);
      return accessConfig && accessConfig["live_device"]
        ? accessConfig["live_device"]
        : [];
    },
  },
  mounted() {
    this.setIntervalWithoutDelay(this.getComputedCardData);
  },
  methods: {
    async getComputedCardData() {
      const param = {
        plantId: this.getSelectedPlantId,
        options: this.availableDeviceWithParameter,
      };
      const usefulData = [];
      const response = await LiveDb.getComputedData(param);
      this.deviceOrder.forEach((device) => {
        if (response.data.message[device]) {
          response.data.message[device].forEach((el) => {
            const newObj = {};
            newObj["data"] = el.value ? el.value : "N/A";
            newObj["unit"] = el.name
              ? el.name.split(" (")[1].replace(")", "")
              : "";
            newObj["header"] = el.name
              ? `${el.name.split(" (")[0]} (${device})`
              : "";
            usefulData.push(newObj);
          });
        }
      });
      this.plantParam = [...usefulData];
    },
  },
  watch: {
    getSelectedPlantId() {
      this.plantParam = [];
      this.setIntervalWithoutDelay(this.getComputedCardData);
    },
  },
};
</script>

<style scoped>
.flickity {
  margin-left: 3px;
  margin-bottom: 4px;
  margin-right: 3px;
}
.carousel-cell {
  width: 200px;
}

.carousel-cell:before {
  display: block;
  text-align: center;
  font-size: 22px;
}
</style>
<style>
.flickity-button {
  width: 18px;
  height: 18px;
}

.flickity-prev-next-button {
  top: 80%;
}
</style>
